import mooseLogoUrl from '@/assets/images/moose-logo.svg'
import type { BrandingConfig } from '@/themes/types'

/**
 * Branding used until the backend exposes tenant configuration.
 * Mirrors the default token values in src/assets/styles/theme.css.
 */
export const defaultTheme: BrandingConfig = {
  appName: 'Moose Admin',
  primaryColor: 'hsl(19 97% 56%)',
  secondaryColor: 'hsl(60 6% 90%)',
  radius: '0.5rem',
  logoUrl: mooseLogoUrl,
}
